import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import BottomNav from './components/layout/BottomNav';
import InstallPrompt from './components/InstallPrompt';
import AuthCallback from './components/auth/AuthCallback';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import LoginPage from './pages/LoginPage';
import FavoritesPage from './pages/FavoritesPage';
import OrdersPage from './pages/OrdersPage';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminDashboardPage from './pages/admin/AdminDashboardPage';
import AdminProductsPage from './pages/admin/AdminProductsPage';
import AdminCouponsPage from './pages/admin/AdminCouponsPage';
import PoliciesPage from './pages/PoliciesPage';
import CookieConsent from './components/CookieConsent';
import WhatsAppFloat from './components/WhatsAppFloat';

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment synchronously for session_id (before ProtectedRoute runs)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/produtos" element={<ProductsPage />} />
        <Route path="/produto/:id" element={<ProductDetailPage />} />
        <Route path="/carrinho" element={<CartPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/favoritos" element={<FavoritesPage />} />
        <Route path="/pedidos" element={<OrdersPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
        <Route path="/admin/produtos" element={<AdminProductsPage />} />
        <Route path="/admin/cupons" element={<AdminCouponsPage />} />
        <Route path="/politica-de-privacidade" element={<PoliciesPage />} />
      </Routes>
      <BottomNav />
      <WhatsAppFloat />
      <InstallPrompt />
      <CookieConsent />
    </>
  );
}

function App() {
  useEffect(() => {
    // Remove injected external badges
    const observer = new MutationObserver(() => {
      document.querySelectorAll('body > div:not(#root), body > a').forEach(el => {
        if (el.id === 'root') return;
        const text = el.textContent || '';
        const html = el.innerHTML || '';
        if (text.includes('Emergent') || html.includes('emergent')) {
          el.style.display = 'none';
          el.style.visibility = 'hidden';
          el.style.opacity = '0';
          el.style.pointerEvents = 'none';
          el.style.position = 'absolute';
          el.style.top = '-9999px';
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: false });
    return () => observer.disconnect();
  }, []);

  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster
        position="top-center"
        toastOptions={{
          style: { background: '#18181B', color: '#FAFAFA', border: '1px solid #27272A', fontSize: '14px' },
          success: { iconTheme: { primary: '#22C55E', secondary: '#FAFAFA' } },
          error: { iconTheme: { primary: '#EF4444', secondary: '#FAFAFA' } },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
